import { Zap } from "lucide-react";

const PowerHourFAB = () => {
  const handleClick = () => {
    const servicesSection = document.querySelector("#services");
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-20 right-6 z-50 md:hidden flex items-center gap-2 bg-primary text-white px-5 py-3 rounded-full shadow-xl font-display font-bold text-sm tracking-wide"
      aria-label="Book Power Hour"
    >
      <Zap className="w-4 h-4" />
      Book Power Hour
    </button>
  );
};

export default PowerHourFAB;
